import axios from 'axios'
import * as Sentry from '@sentry/react'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8082'

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear()
      window.location.href = '/auth/login'
    } else {
      Sentry.addBreadcrumb({
        category: 'api',
        message: `${error.config?.method?.toUpperCase()} ${error.config?.url} → ${error.response?.status}`,
        level: 'error',
      })
    }
    return Promise.reject(error)
  },
)
